import { createSlice } from "@reduxjs/toolkit";

const programmeCommercialSlice = createSlice({
    name:'programmeCommercial',
    initialState:{
        programmeCommercial:[]
    },
    reducers: {
        addProgrammeCommercial : (state,action) => {
            state.programmeCommercial = [...state.programmeCommercial,action.payload]
        },
        // removeOccupation(){
        //     return state.occupation.filter((item)=> item.id != action.payload);
        // }
    }
});

export const { addProgrammeCommercial } = programmeCommercialSlice.actions;
export default programmeCommercialSlice.reducer;